import React, { Fragment } from "react";
import StandardModal from "@/js/components/shared/StandardModal";
import { DangerButton } from "@/js/components/shared/button/DangerButton";
import { SecondaryButton } from "@/js/components/shared/button/SecondaryButton";

interface Props {
	open: boolean;
	classroomName: string;
	onDelete: () => void;
	onCancel: () => void;
}

export const DeleteClassConfirmModal: React.FC<Props> = ({ open, classroomName, onDelete, onCancel }) => {
	return (
		<StandardModal
			title={`Delete "${classroomName}"`}
			open={open}
			close={onCancel}
			actions={
				<Fragment>
					<DangerButton className="mui-flat-button" label="Delete" data-cy="confirm-class-delete" onClick={onDelete} />
					<SecondaryButton className="mui-flat-button" label="Cancel" onClick={onCancel} />
				</Fragment>
			}
			size="medium"
			contentClassName="DeleteClassConfirmModal_content"
		>
			Are you sure you want to delete this class?
		</StandardModal>
	);
};
